import { useEffect, useState, useContext } from 'react';
import { DataChart, Text, Box, ResponsiveContext, ThemeContext } from 'grommet';
import { ChartCard } from '../../templates/dashboards';
import { defaultWindow, formatCurrency, DEMO_DATE, REPORT_WINDOW_MAP } from '../../helpers';
import { getGlassStyle } from '../../helpers/GlassStyles';

const MOCK_DATA = require('./mockdata/consumption.json');

export const CostByYear = ({ period }) => {
  const [values, setValues] = useState(null);
  const [reportWindow, setReportWindow] = useState(defaultWindow);

  const size = useContext(ResponsiveContext);
  const isMobile = ['xsmall', 'small'].includes(size);
  const theme = useContext(ThemeContext);
  const isDarkMode = theme.dark;

  const glass = getGlassStyle(isDarkMode, 1.015);

  useEffect(() => {
    setReportWindow(prevWindow => ({
      ...prevWindow,
      begin: new Date(new Date(DEMO_DATE).setDate(prevWindow.end.getDate() - REPORT_WINDOW_MAP[period])),
    }));
  }, [period]);

  useEffect(() => {
    if (MOCK_DATA.consumption) {
      const nextValues = [];
      MOCK_DATA.consumption.forEach(datum => {
        const dataPointDate = new Date(datum.endDate);
        if (dataPointDate > reportWindow.begin && dataPointDate < reportWindow.end) {
          const val = parseFloat(datum.cost.replace(/[$,]/gm, ''));
          const existing = nextValues.find(el => el.key === datum.year);
          if (!existing) nextValues.push({ key: datum.year, value: val });
          else existing.value = Number((existing.value + val).toFixed(2));
        }
      });
      setValues(nextValues.sort((a, b) => a.key - b.key));
    }
  }, [reportWindow]);

  return (
    <Box>
      <ChartCard
        title="Annual Spend"
        subtitle={`Period: ${period}`}
        elevation="none"
        height={isMobile ? "medium" : { min: "384px" }}
        /* 1. Blur on click to clear focus state */
        onClick={(e) => {
          if (e.currentTarget) e.currentTarget.blur();
          window.dispatchEvent(new CustomEvent('show-coming-soon'));
        }}
        /* 2. Explicitly disable focus indicator */
        focusIndicator={false}
        /* 3. Defensive styling */
        style={{ 
          ...glass.container,
          outline: 'none',
          boxShadow: 'none'
        }}
        onMouseEnter={glass.hover}
        onMouseLeave={glass.leave}
      >
        {values && (
          <Box flex fill="vertical" pad={{ top: 'small' }}>
            <DataChart
              data={values.map(v => ({ date: v.key, cost: v.value }))}
              series={[
                { property: 'date', label: 'Year', render: v => <Text size="xsmall" color="text-strong" weight="bold">{v}</Text> },
                { property: 'cost', label: 'Spend', render: v => <Text size="xsmall" color="text-strong" weight="bold">{formatCurrency(v)}</Text> },
              ]}
              axis={{ x: { property: 'date' }, y: { property: 'cost' } }}
              chart={{ property: 'cost', thickness: 'xxsmall', type: 'line' }}
              detail
              guide={{ y: { granularity: 'fine' } }}
              fill
            />
          </Box>
        )}
      </ChartCard>
    </Box>
  );
};
